<template>
	<div>
		<h2 v-if="heading" class="c-checklist-filter__heading heading-boarder">
			{{ heading }}
		</h2>
		<ul class="c-checklist-filter__list">
			<slot></slot>
		</ul>
	</div>
</template>

<script>
export default {
	name: "VChecklistFilter",
	props: {
		heading: {
			type: String
		}
	}
};
</script>
